import { render, staticRenderFns } from "./history-modal.vue?vue&type=template&id=c634880a&"
import script from "./history-modal.vue?vue&type=script&lang=js&"
export * from "./history-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports